var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"headbar"}},[_c('div',{staticClass:"topTimer"},[_c('span',[_vm._v(_vm._s(_vm.timerCount))]),_vm._v(" 초 후 새로고침\n    "),_c('span',{staticClass:"timerUpdate"},[_vm._v("update")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lastUpdateDate))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02507e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 